import {useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {VisuallyHidden} from '@primer/react'
import {clsx} from 'clsx'

import {repoStackDetailRoute} from '../../routes/repo-stack-detail-route'
import {stateSegments} from './stack-segments'
import {StackProgressMeter} from './StackProgressMeter'
import meterStyles from './StackProgressMeter.module.css'
import styles from './StackDetailHeader.module.css'

const legendStates = ['merged', 'queued', 'open', 'draft', 'closed'] as const

export function StackProgressSummary() {
  const {data} = useSuspenseRouteQuery(repoStackDetailRoute, 'mainQuery')
  if (!data.stack) return null
  const segments = stateSegments(data.pullRequests)
  const merged = segments.filter(state => state === 'merged').length

  return (
    <div className={styles.ProgressSummary}>
      <StackProgressMeter segments={segments} />
      <VisuallyHidden>
        {merged} of {data.stack.size} pull requests merged
      </VisuallyHidden>
      <div className={styles.Legend}>
        {legendStates.map(state => {
          const count = segments.filter(segment => segment === state).length
          return count > 0 ? (
            <span key={state} className={styles.LegendItem}>
              <span className={clsx(styles.Swatch, meterStyles[state])} aria-hidden="true" />
              <span>
                {count} {state}
              </span>
            </span>
          ) : null
        })}
      </div>
    </div>
  )
}
